module.exports = __webpack_public_path__ + "images/emoji/chart_with_upwards_trend.bf650005cbfa924b6213.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chart_with_upwards_trend.png
// module id = wmcG
// module chunks = 13